import { create } from 'zustand'
import { persist } from 'zustand/middleware';

import { TicketRequest } from '../types/tickets/types'

type TicketFiltersStore = {
  filters: TicketRequest | null
  setFilters: (filters: TicketRequest) => void
  updateFilters: (filters: Partial<TicketRequest>) => void
  clearFilters: () => void
}

export const useTicketFiltersStore = create<TicketFiltersStore>()(
  persist(
    (set) => ({
      filters: null,

      setFilters: (filters) => set({ filters }),

      updateFilters: (newFilters) =>
        set((state) => ({
          filters: state.filters
            ? { ...state.filters, ...newFilters }
            : null,
        })),

      clearFilters: () => set({ filters: null }),
    }),
    {
      name: 'ticket-filters-storage',
    }
  )
)